<template>
  <modal-container :id="'addSupportingDocument'" small>
    <form @submit.prevent>
      <div class="modal-header">
        <h5 class="modal-title">Upload Document</h5>
      </div>
      <div class="modal-body">
        <base-field label="Name">
          <base-input v-model="caption" placeholder="caption" required />
        </base-field>
      </div>
      <div class="modal-footer">
        <base-button data-dismiss="modal">
          Cancel
        </base-button>
        <button-upload :caption="caption" primary submit tag="supportingDocument" @uploaded="uploaded">
          Upload File
        </button-upload>
      </div>
    </form>
  </modal-container>
</template>

<script>
import ButtonUpload from './ButtonUpload.vue'
import ModalContainer from './ModalContainer.vue'

export default {
  data: () => ({
    caption: ''
  }),

  name: 'ProjectAddSupportingDocument',

  components: {
    ButtonUpload,
    ModalContainer
  },

  methods: {
    async uploaded (document) {
      await this.$store.dispatch('core/projects/documents/add', document)

      $('#addSupportingDocument').modal('hide')

      this.$flash.success('Document successfully uploaded.')
    }
  }
}
</script>
